import './Filters.css';
import { useState} from 'react';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon';

// Define the order in which filters should be displayed
const FILTER_ORDER = [
    'categories',
    'regions',
    'countries',
    'states',
    'extractedTime',
    'updateTime',
    'sourceNames'
];

export default function Filters({filtersData, selectedFilters, setSelectedFilters}){
    console.log(filtersData)
    //local search state per filter
    const [searchMap, setSearchMap] = useState({});
    
    // Sort filter keys: ordered filters first, then any others alphabetically
    const sortedFilterKeys = Object.keys(filtersData).sort((a, b) => {
        const indexA = FILTER_ORDER.indexOf(a);
        const indexB = FILTER_ORDER.indexOf(b);
        
        // If both are in the predefined order
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }
        // If only a is in the predefined order, it comes first
        if (indexA !== -1) return -1;
        // If only b is in the predefined order, it comes first
        if (indexB !== -1) return 1;
        // If neither is in the predefined order, sort alphabetically
        return a.localeCompare(b);
    });
    
    //Handle Checkbox change
    function handleChange(filterKey, value){
        //radio button filters
        if(filterKey === "extractedTime" || filterKey === "updateTime"){
            setSelectedFilters(prev => ({
                ...prev,
                [filterKey]: [value]
            }));
            return;
        }
        setSelectedFilters((prev) => {
            const current = prev[filterKey] || [];
            const updated = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
            return {
                ...prev,
                [filterKey]:updated
            };
        });
    }

    //Reset single filter
    function handleReset(filterKey){
        setSelectedFilters((prev) => ({
            ...prev,
            [filterKey]: []
        }));
    }

    //handle search input per filter
    function handleSearch(filterKey, value){
        setSearchMap((prev)=>({
            ...prev,
            [filterKey]:value
        }));
    }

    function formatTitle(key){
        // Custom title mappings
        if (key === 'sourceNames') return 'Source';
        if (key === 'extractedTime') return 'Information extracted time';
        if (key === 'updateTime') return 'Last update time';
        
        return key.replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());
    }

    return (
        <div className="filter-box">
            {/*Dynamic Filters */}
            {sortedFilterKeys.map((filterKey)=>{
                const options = filtersData[filterKey] || [];
                const selectedValues = selectedFilters[filterKey] || [];
                const searchText = searchMap[filterKey] || "";

                //filter options based on search - use label for time filters, value for others
                const filteredOptions = options.filter((item)=> {
                    const searchTarget = item.label || String(item.value);
                    return searchTarget.toLowerCase().includes(searchText.toLowerCase());
                });
                return(
                    <div key={filterKey} className="filter-section">
                        <div className="filter-header">
                            <span className='filter-title'>
                                {formatTitle(filterKey)}
                                {(filterKey === 'extractedTime' || filterKey === 'updateTime') && (
                                    <SlTooltip content={filterKey === 'extractedTime' ? 'Displays the articles used to extract information based on the selected option.' : 'Displays articles that have undergone updates or revisions pertaining to the selected option.'}>
                                        <SlIcon 
                                        weight="medium"
                                        size="3xl"
                                        src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0idmFyKC0tY2RzLWljb24td2VpZ2h0LCAxLjUpIiBzdHlsZT0iYm94LXNpemluZzogYm9yZGVyLWJveDsgb3ZlcmZsb3c6IHZpc2libGU7IHBhZGRpbmc6IHZhcigtLWNkcy1pY29uLXBhZGRpbmcsIDApOyB0cmFuc2l0aW9uOiB2YXIoLS1jZHMtaWNvbi10cmFuc2l0aW9uLCAwcyk7Ij48ZyBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0xNC4yNSAxNi41SDEzLjVBMS41IDEuNSAwIDAgMSAxMiAxNVYxMS4yNWEuNzUuNzUgMCAwIDAgLS43NS0uNzVIMTAuNSIvPjxwYXRoIGQ9Ik0xMS42MjUgNi43NUEuMzc1LjM3NSAwIDEgMCAxMiA3LjEyNWEuMzc1LjM3NSAwIDAgMCAtLjM3NS0uMzc1aDAiLz48cGF0aCBkPSJNLjc1IDEyQTExLjI1IDExLjI1IDAgMSAwIDIzLjI1IDEyIDExLjI1IDExLjI1IDAgMSAwIC43NSAxMloiLz48L2c+PC9zdmc+"
                                        className="info-icon" name="info-circle" style={{ marginLeft: '6px', cursor: 'pointer', fontSize: '14px', color: '#461e96' }} />
                                    </SlTooltip>
                                )}
                            </span>
                            {filterKey !== 'extractedTime' && filterKey !== 'updateTime' && (
                                <button onClick={() => handleReset(filterKey)}>Reset</button>
                            )}
                        </div>
                        {filterKey !== 'extractedTime' && filterKey !== 'updateTime' && (
                        <div className="search-box">
                            <img src="/Icons/find.svg" className="search-icon" alt="Search filters" />
                            <input 
                        type="text"
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => handleSearch(filterKey,e.target.value)}
                        className="filter-search"
                        />
                        </div>
                        )}
                        
                        {/*options */}
                        <div className="filter-options">
                            {filterKey!=="extractedTime" && filterKey!=="updateTime" ? filteredOptions.map((item, index)=> (
                                <div key={index} className="checkbox-item">
                                    <input type="checkbox"
                                    checked = {selectedValues.includes(item.value)}
                                    onChange={() => handleChange(filterKey, item.value)}
                                    />
                                    <span className="checkbox-label" onClick={() => handleChange(filterKey, item.value)}>{item.value}</span>
                                </div>   
                            )) :
                            filteredOptions.map((item, index)=> (
                                <div key={index} className="checkbox-item">
                                    <input type="radio"
                                    name={filterKey}
                                    checked = {selectedValues.includes(item.value)}
                                    onChange={() => handleChange(filterKey, item.value)}
                                    />
                                    <span className="checkbox-label" onClick={() => handleChange(filterKey, item.value)}>{item.label || item.value}</span>
                                </div>   
                            ))}
                        </div>
                    </div>

                )
            })}
        </div>
    )
}